module.exports = __webpack_public_path__ + "img/sb03.d41606cd.png";